var map = {
	"./combine/avatar.jpg": "2e6c",
	"./default/avatar.jpg": "f42b",
	"./fooyo/avatar.jpg": "25c4",
	"./tiny_toes/avatar.jpg": "54d1",
	"./wholesale/avatar.jpg": "899c",
	"./zoo/avatar.jpg": "5bbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "222b";